<template>
    <div style="clear: both; padding-top: 20px;">
       
       <div class="classbox"> 
            <div class="fenleibiaoti">
                <h2>
                  <!-- <em>更多应用></em> -->
                    {{ itemdata.name }}</h2>
            </div>
            <div class="fenleimain">
            <div :class="ismore?'indexbigcell':'indexcell'">
                 <ul>
                     <li v-for="(item,index) in itemdata.oslist" :key="index"  @mouseenter="handleMouseEnter(item.id)"   @mouseleave="handleMouseLeave(item.id)" @click="goosid(item.id)">
                        <div v-if="showshiyong && item.id==dqosid" class="shiyongbtn">使用</div>
                        <dl>
                          <dt>
                            <img :src="'http://121.41.29.241:9595/'+item.oslogo" />
                          </dt>
                          <dd>
                            <h5>{{ item.osname }}</h5>
                            <p>{{ item.osprofile }}</p>
                          </dd>
                        </dl>
                      </li>     
                      
                      
                 </ul>    
            </div>          
            </div>
        </div>
    </div>
</template>

<script>

import { getappdetail } from "@/api/api";
    

    export default {

        props:["itemdata"],

        watch:{
            itemdata:function(newval,oldval){
                console.log('eeee',newval);
                this.itemdata = newval;
            }
        },
        created(){
            console.log('itemdata',this.itemdata);
        },

        data() {
            return {
                blogo02: require("@/assets/images/b-icon_002.jpg"),
                ismore:false,
                ositemlist:[],
                showshiyong:false,
                dqosid:''
            }
        },
        methods: {
         handleMouseEnter(dqosid){
          this.dqosid = dqosid;
          //console.log('dqosid',dqosid);
          this.showshiyong = true;
         },
         handleMouseLeave(){
          this.dqosid = "";
          this.showshiyong = false;
         }, 
        goosid(id){
              
          getappdetail(id).then(res=>{
            console.log('res',res);
            var width = 1380;
            const height = 900
            // 计算居中位置
            const left = (window.screen.width - width) / 2;
            const top = (window.screen.height - height) / 2 - 50;

            console.log("left",left)

            var osurl = res.data.rows[0].osurl;
            console.log('osurl',osurl);
            window.open (osurl, 'newwindow', `width=${width},height=${height},left=${left},top=${top},toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`) 

            // window.open (osurl, 'newwindow', `width=${width},height=${height},left=${left},top=${top},toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no`) 
//写成一行 
            //this.ositemlist = res.data.oslist;
          })

        }  
        },
    }
</script>

<style lang="scss" scoped>

.classbox{ background: #fff; padding-top: 20px; margin-right: 20px;  border-radius: 10px; padding-bottom: 20px; }
.classbigbox{ background: #fff; padding-top: 20px; margin-right: 20px;  border-radius: 10px;}


.classbox h2{ padding-bottom:15px;padding-left: 30px; border-bottom: 1px solid #f5f5f5; color:#000 }
.classbox h2 em{ float: right; font-size:15px; padding-right: 20px;color:#0090ff; font-weight: bold; }

.indexcell{ padding-right: 10px;padding-left:20px; padding-top: 10px;overflow: hidden; padding-bottom: 10px; }
.indexbigcell{ padding-right: 10px;padding-left:20px; padding-top: 10px; background: #fff;}

.indexcell,.indexbigcell {
        ul li {
                width: 20%;
                float: left;
                height: 100px; 
                border-left: none;
                border-top: none;
                position: relative; cursor: pointer;
                span{
                  position: absolute;right: 0; top:0px; background: #fff; padding: 5px;
                  i{ float: left; padding-left:5px; padding-right: 5px;color: #999;}
                  img{float: left; margin-top:2px;}
                }
                dl {
                  padding-top:20px;
                  display: flex; justify-content: left; align-items: center;
                  dt {
                    
                    width: 70px;
                    padding-left: 15px;
                    padding-top: 5px;width: 55px; height: 55px; display:flex; align-items: center; justify-content: center;

                    img { 
                      width: 46px; border-radius: 8px;
                    }
                  }


                  dd {
                    padding-left: 15px;

                    h5 {
                      font-size: 15px;
                      color: #000;
                     
                    }
                    p {
                      color: #999;
                      font-size: 12px;
                      overflow: hidden;
                       text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2; padding-right: 10px;
                        -webkit-box-orient: vertical;
                    }
                  }
                }
              }
              ul li:last-child {
              }
              ul li:first-child {
                border-left: none;
              }

              ul li:hover{ box-shadow: 0 0 8px #ddd; border-radius: 5px;}

              @media screen and (max-width: 1420px) {
                /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
                ul li {
                  width: 25%;
                }
              }
      }


      .shiyongbtn{display:line-block; text-align: center; z-index: 5;  right: 13px; top:35px; width: 50px; height: 30px; position: absolute; color: #fff; border-radius: 20px; background: rgba(39,196,47,0.8) !important; line-height: 30px; padding: 0 !important;}



</style>


// WEBPACK FOOTER //
// src/components/classify/classlist.vue